
import Vue from 'vue'

export default Vue.extend({
   name: 'ToggleButton',
   props: {
      id: String,
      label: String,
      value: Boolean,
      description: String,
      tooltip: String,
   },
   data() {
      return {
         initialValue: false,
         innerValue: false,
         dirty: false,
      }
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: boolean) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onClick() {
         this.innerValue = !this.innerValue
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
})
